
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/plan/pause",
      function () {
        return require("private-next-pages/profile/plan/pause.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/plan/pause"])
      });
    }
  